<div class="input-wrapper-list" [formGroup]="form">
    <mat-label class="mat-label-general">
        <!-- Bolt Quantity -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.BOLT_QUANTITY' | transloco }}
    </mat-label>

    <input
        matInput
        type="number"
        class="input-form-class"
        formControlName="boltQuantity"
        name="boltQuantity"
        #tooltip="matTooltip"
        matTooltip="Enter only digits, minimum allowed is 1"
        [matTooltipDisabled]="form.get('boltQuantity').valid"
        (change)="boltQuantityChange($event)"
        [ngClass]="form.get('boltQuantity').valid ? '' : 'highLight'"
    />
</div>
